import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { faqs } from '../../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-[#F6F8FC] px-4 py-16 sm:px-6 lg:py-24" aria-labelledby="faq-title" data-id="element-109" data-mp="12355scfbdgze">
      <div className="mx-auto max-w-3xl" data-id="element-110" data-mp="1pspp4wfdqg97">
        <SectionHeading title={<span id="faq-title" data-id="element-112" data-mp="1urk5zstsduqo">Frequently Asked Questions</span>} data-id="element-111" data-mp="1urao6siwatw2" />
        <div className="mt-10 space-y-3" data-id="element-113" data-mp="1ut557vr1q1uv">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="rounded-2xl bg-white ring-1 ring-navy/10" data-id="element-114" data-mp="1l0pmuxbu7b9g" data-mpi={i}>
                <h3 data-id="element-115" data-mp="28qjwl60v0jph">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 p-5 text-left font-display text-base font-bold leading-snug text-navy sm:text-lg" data-id="element-116" data-mp="28q0mgbhgazm0">
                    <span data-id="element-117" data-mp="2jpb1vnf5acz4">
                      {i + 1}. {f.q}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-brand text-white' : 'bg-brand-50 text-brand'}`} data-id="element-118" data-mp="2yi4w6ez2sxnu">
                      <PlusIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-119" data-mp="32i59txecp4tu" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-120" data-mp="3hctkdpylytgb">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-121" data-mp="3cgl05y5k0a2a">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-ink-muted sm:text-base" data-id="element-122" data-mp="2bqrapxrmyskp">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <CtaButton label="Get instant access for $27" className="mt-10" data-id="element-123" data-mp="2lnm7oc89gkwv" />
      </div>
    </section>;
}